export const validateURLMainPage = url => {
  const regex =
    /^(https?:\/\/)?([a-zA-Z0-9-]+\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
  return regex.test(url);
};
